import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../../ui/Button";
import { AddDeviceDialog } from "./AddDeviceDialog";

/**
 * Add device for someone with no organisation of their own, none at all or a Guest elsewhere only (users-and-roles
 * UR-10, bug log A11): the first claim makes their personal organisation, "My devices", and the app switches to it.
 */
export function FirstDevice({ guest }: { guest?: boolean }) {
  const { t } = useTranslation();
  const [adding, setAdding] = useState(false);
  const [added, setAdded] = useState<string>();
  return (
    <div className="my-4 rounded-md border border-gray-200 bg-white p-4 text-sm">
      <p className="text-gray-900">{t(guest ? "addDevice.firstGuest" : "addDevice.first")}</p>
      <Button className="mt-3" onClick={() => setAdding(true)}>
        {t("addDevice.open")}
      </Button>
      <div role="status" aria-live="polite">
        {added && (
          <p className="mt-3 rounded-md bg-green-50 p-2 text-green-900">{t("addDevice.added", { name: added })}</p>
        )}
      </div>
      <AddDeviceDialog
        open={adding}
        onClose={() => setAdding(false)}
        onAdded={(d) => setAdded(d.name ?? d.device_id)}
      />
    </div>
  );
}
